import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

export class HttpService {
  constructor(private api: AxiosInstance) {}

  async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await this.api.get(url, config);
    return response.data;
  }


  async getWithEtag<T>(url: string, config?: AxiosRequestConfig): Promise<{ etagStatus: number, data?: T }> {
  try {
    const response: AxiosResponse<T> = await this.api.get(url, {
      ...config,
      validateStatus: (status) => {
        return status === 200 || status === 304; 
      }
    });

    if (response.status === 304) {
      return { etagStatus: 304 };
    }

    return { etagStatus: 200, data: response.data };

  } catch (err) {
    console.error("API Error:", err);
    throw err;
  }
}



  async post<T>(
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const response: AxiosResponse<T> = await this.api.post(url, data, config);
    return response.data;
  }

  async put<T>(
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const response: AxiosResponse<T> = await this.api.put(url, data, config);
    return response.data;
  }

  async patch<T>(
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const response: AxiosResponse<T> = await this.api.patch(url, data, config);
    return response.data;
  }

  async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await this.api.delete(url, config);
    return response.data;
  }

  // Direct access to axios instance for complex operations
  getInstance(): AxiosInstance {
    return this.api;
  }
}
